import './style/index.less';
import OpenPlatformManager from './OpenPlatformManager';

export * from './OpenPlatformManager';

export default OpenPlatformManager;
